<template lang="pug">
#timeMachine.modal.fade.modal-common(tabindex="-1" role="dialog" aria-labelledby="timeMachine"  )
  .modal-dialog.modal-dialog-scrollable.modal-dialog-centered(role='document')
    .modal-content
      .modal-header
        .modal-title {{sourceDetails.homeTeam }} -vs- {{ sourceDetails.awayTeam }}
        .header-icons
          span( @click="updateInformationShow()") 
            i.fal.fa-info-circle
          span( @click="hideMe()") 
            i.fal.fa-times
      .modal-body
        timeMachine(:rangeValue="rangeValue" @update-range="updateRangeValue", :rangeMin="time_machine.min")
        .time-machine-odds-wrapper
          .odds-column
            .odds-header {{ $t("ui.hdp") }}
            timeMachineOddsItem(:source="sourceDetails" :details="time_machine.minutesOddsData" oddsKey="hh"
            :oddsKeyInd="rangeValue" label="ODD_Home" :typ="oddsType" dataType="1" homeAway="1" @update-range="updateRangeValue")

            timeMachineOddsItem(:source="sourceDetails" :details="time_machine.minutesOddsData" oddsKey="ha" 
            :oddsKeyInd="rangeValue" label="ODD_Away" :typ="oddsType" dataType="2" homeAway="2" @update-range="updateRangeValue")
                  
          .odds-column
            .odds-header {{ $t("ui.ou") }}
            timeMachineOddsItem(:source="sourceDetails" :details="time_machine.minutesOddsData" oddsKey="ov"
            :oddsKeyInd="rangeValue" label="ODD_Over" :typ="oddsType" dataType="3" homeAway="1" @update-range="updateRangeValue")
            
            timeMachineOddsItem(:source="sourceDetails" :details="time_machine.minutesOddsData" oddsKey="ud"
            :oddsKeyInd="rangeValue" label="ODD_Under" :typ="oddsType" dataType="4" homeAway="2" @update-range="updateRangeValue")
        .tm-info(:data-open="isInfoShow" )
          .tm-info-body
            .tm-icon-info
              .fal.fa-info-circle
            .tm-info-content
              .tm-close
                .tm-close-btn( @click="updateInformationShow()") 
                  i.fal.fa-times
              .tm-text  
                p {{ $t("message.time_machine_information_HDP") }} {{ $t("message.time_machine_information_OU") }}
              


</template>
<script>
import timeMachine from "@/components/mobile/timeMachine/timeMachine";
import timeMachineOddsItem from "@/components/mobile/timeMachine/timeMachineOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    timeMachine,
    timeMachineOddsItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      rangeValue: 6,
      error: "",
      isInfoShow: false,
      clearData: true,
      sourceDetails: {}
    };
  },
  computed: {
    betting() {
      return this.$store.getters.betting;
    },
    time_machine() {
      return this.$store.getters.timeMachine || {};
    }
  },
  destroyed() {
    $("#timeMachine").off("hidden.bs.modal", this.handleHiddenMe);
  },
  mounted() {
    $("#timeMachine").on("hidden.bs.modal", this.handleHiddenMe);
    EventBus.betTimeMachineDatetime = this.runBetTimeMachine;
    EventBus.setupErrorMessage = this.getTimeMachineErrorResponse;
    EventBus.cancelBetTimeMachineDatetime = this.cancelBetTimeMachine;
  },
  methods: {
    showMe() {
      $("#timeMachine").modal("show");
    },
    hideMe() {
      document.activeElement.blur();
      $("#timeMachine").modal("hide");
    },
    updateInformationShow() {
      this.isInfoShow = !this.isInfoShow;
    },
    handleHiddenMe() {
      this.sourceDetails = {};
      this.error = "";
      this.isInfoShow = false;
      this.rangeValue = 6;
      this.$store.dispatch("layout/setShowTimeMachine", false);
      if (!!this.clearData) {
        this.$store.commit("timemachine/RESET_STATE");
      }
    },
    updateRangeValue(val) {
      const tm = this.time_machine;
      if (tm.runningTime && val < tm.min) {
        this.rangeValue = tm.min;
      } else {
        this.rangeValue = val;
      }
    },
    runBetTimeMachine(source) {
      if (!source.isTimeMachine) {
        this.cancelBetTimeMachine(false);
      }
      this.sourceDetails = source;
      const tm = this.time_machine;
      if (source.isLive && this.rangeValue < tm.min) {
        this.rangeValue = tm.min;
      }
      this.showMe();
    },
    getTimeMachineErrorResponse(err) {
      this.$store.dispatch("layout/setShowTimeMachine", false);
      switch (err.status) {
        case "startTimeRequired":
        case "endTimeRequired":
        case "oddsTypeIDRequired":
        case "commissionRequired":
        case "requestTimeRequired":
        case "statusRequired":
        case "invalidStartTime":
        case "invalidEndTime":
        case "invalidOddsTypeID":
        case "invalidCommission":
        case "invalidRequestTime":
        case "invalidStatus":
        case "invalidAlgoMatchInfo":
        case "invalidAlgoSliderLeagueInfo":
        case "invalidAlgoSliderMinutesWeight":
        case "invalidAlgoSliderBetType":
          this.error = this.$t("error." + err.status);
          break;
        case "account_status_suspend":
          this.error = this.$t("error.SUSPEND");
          break;
        case "invalidSliderTimeRange":
        case "invalidMOMatchOdds":
        case "invalidProviderMOMatch":
        case "invalidBet":
        case "invalidBetTime":
        case "oddsPause":
        case "oddsNotAllowedBet":
        case "invalidRTSRunningScoreDetails":
        case "invalidProviderGoalTimeLine":
        case "invalidRTSMatchOdds":
        case "invalidProviderSlider":
        case "invalidCombineBetTypeAndOddsFormat":
        case "invalidRunningLabelAndTime":
        case "invalidTeamScoreAndTotalScore":
        case "betTimeOver":
        default:
          this.cancelBetTimeMachine(false);
          this.error = this.$t("error.marketClose");
          break;
      }
      if ($("#timeMachine").hasClass("show")) this.hideMe();
      this.$swal("Error", this.$t(this.error), "error");
    },
    cancelBetTimeMachine(c) {
      this.clearData = c;
      this.hideMe();
    }
  }
};
</script>
